import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
import _ from 'lodash'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_LOCKER_ERROR = 'CREATE_LOCKER_ERROR'
export const CREATE_LOCKER_SUCCESS = 'CREATE_LOCKER_SUCCESS'
export const DELETE_LOCKER_ERROR = 'DELETE_LOCKER_ERROR'
export const DELETE_LOCKER_SUCCESS = 'DELETE_LOCKER_SUCCESS'
export const UPDATE_LOCKER_ERROR = 'UPDATE_LOCKER_ERROR'
export const UPDATE_LOCKER_SUCCESS = 'UPDATE_LOCKER_SUCCESS'
export const SELECT_LOCKER_SUCCESS = 'SELECT_LOCKER_SUCCESS'

// ------------------------------------
// Logic Actions
// ------------------------------------

export function selectLocker(locker) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_LOCKER_SUCCESS,
      payload: locker
    })
  }
}
// ------------------------------------
// Basic Actions
// ------------------------------------
export function createLocker(locker) {
  return (dispatch, getState) => {
    const { firebase, auth } = getState()
    const now = moment().format()
    const newLocker = {
      createdBy: auth.hbUserKey,
      updatedBy: auth.hbUserKey,
      createdAt: now,
      updatedAt: now,
      name: locker.name,
      available: locker.available,
      customer: locker.customer || null,
      expirationDate: locker.expirationDate || null
    }
    firebase.child('lockers').push(newLocker, error => {
      if (error) {
        console.error('ERROR @ createLOCKER :', error)
        dispatch({
          type: CREATE_LOCKER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function deleteLockers(lockers) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    lockers = _.isArray(lockers) ? lockers : [lockers]
    let fanout = {}
    for (let i = 0; i < lockers.length; i++) {
      fanout[`lockers/${lockers[i].key}`] = null
    }
    firebase.update(fanout, error => {
      if (error) {
        console.error('ERROR @ deleteLocker :', error)
        dispatch({
          type: DELETE_LOCKER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateLocker(locker, changes) {
  return (dispatch, getState) => {
    const { firebase } = getState()
    Object.keys(changes).map(key => {
      if (changes[key] === void 0) {
        changes[key] = null
      }
      return null
    })

    firebase.child('lockers/' + locker.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateLocker :', error)
        dispatch({
          type: UPDATE_LOCKER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerLockersListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('lockers')
    ref.on('child_added', snapshot => {
      let locker = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_LOCKER_SUCCESS,
        payload: locker
      })
    })

    ref.on('child_changed', snapshot =>
      dispatch({
        type: UPDATE_LOCKER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )

    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_LOCKER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createLocker,
  updateLocker,
  registerLockersListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_LOCKER_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(locker => locker.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_LOCKER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_LOCKER_SUCCESS]: (state, action) =>
    Object.assign({}, state, { selectedLocker: action.payload }),
  [UPDATE_LOCKER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(locker => {
        return locker.key === action.payload.key ? action.payload : locker
      })
    }),
  [UPDATE_LOCKER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_LOCKER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(locker => {
        return locker.key !== action.payload.key
      })
    }),
  [DELETE_LOCKER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedLocker: {} }
export default function lockerReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/locker.js